import React, { useState, useEffect, useCallback } from 'react'
import {
	Box,
	Typography,
	IconButton,
	Avatar,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Button,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiBase } from '../../services/apiBase'
import UserLayout from '../../layouts/UserLayout'
import { api } from '../../utils/api'

const CustomerDetail = () => {
	const navigate = useNavigate()
	const { state } = useLocation()
	const customerData = state?.customerData
	const [referrals, setReferrals] = useState([])

	const fetchCustomerDetails = useCallback(async () => {
		try {
			const referralAcc = await apiBase.get(`${api.GET_CUSTOMER_REFERRAL}?customersId=${customerData.id}`)
			setReferrals(referralAcc.data || [])
		} catch (error) {
			console.error('Error fetching customer details:', error)
		}
	}, [customerData.id])

	useEffect(() => {
		fetchCustomerDetails()
	}, [fetchCustomerDetails])

	const handleOrderHistoryClick = async () => {
		try {
			const response = await apiBase.get(`${api.GET_CUSTOMER_ORDERS}?userid=${customerData.id}`)
			if (response) {
				navigate(`/admin/zalo-mini-app/orders/${customerData.id}`, {
					state: {
						userOrders: response,
						fromCustomerDetail: true,
					},
				})
			}
		} catch (error) {
			console.error('Error fetching order history:', error)
		}
	}

	const handleHistoryPointsClick = async () => {
		navigate(`/admin/zalo-mini-app/customer/${customerData.id}/customer-history-points`)
	}

	return (
		<UserLayout>
			<Box sx={{ bgcolor: '#fff', minHeight: '100vh', maxWidth: '992px', margin: '0 auto' }}>
				{/* Header */}
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 2,
						p: 2,
						background: '#fff',
						borderBottom: '1px solid #e0e0e0',
						position: 'sticky',
						top: 0,
						zIndex: 1000,
					}}>
					<IconButton onClick={() => navigate(-1)}>
						<ArrowBackIcon />
					</IconButton>
					<Typography variant='h6' sx={{ ml: 1, textAlign: 'left' }}>
						Khách hàng
					</Typography>
				</Box>

				{/* Customer Info */}
				{customerData && (
					<Box sx={{ p: 2 }}>
						<Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
							<Avatar src={customerData.photo} sx={{ width: 56, height: 56, mr: 2 }} />
							<Box>
								<Typography variant='h6'>{customerData.name}</Typography>
								<Typography color='text.secondary'>{customerData.phone}</Typography>
								<Typography color='primary'>Điểm: {customerData.point || 0}</Typography>
							</Box>
						</Box>

						<Button
							fullWidth
							variant='outlined'
							onClick={handleOrderHistoryClick}
							sx={{
								mb: 3,
								color: '#00AB55',
								borderColor: '#00AB55',
								'&:hover': {
									borderColor: '#007B55',
									backgroundColor: 'rgba(0, 171, 85, 0.08)',
								},
								textTransform: 'none',
							}}>
							Lịch sử đơn hàng
						</Button>
						<Button
							fullWidth
							variant='outlined'
							onClick={handleHistoryPointsClick}
							sx={{
								mb: 3,
								color: '#00AB55',
								borderColor: '#00AB55',
								'&:hover': {
									borderColor: '#007B55',
									backgroundColor: 'rgba(0, 171, 85, 0.08)',
								},
								textTransform: 'none',
							}}>
							Lịch sử điểm
						</Button>

						{/* Referrals */}
						<Box sx={{ mb: 2 }}>
							<Typography sx={{ mb: 1 }}>Số người giới thiệu: {customerData.totalReferral || 0}</Typography>
							<List sx={{ p: 0 }}>
								{referrals?.map((referral) => (
									<ListItem
										key={referral._id}
										sx={{
											borderBottom: '1px solid #eee',
											py: 1.5,
										}}>
										<ListItemAvatar>
											<Avatar src={referral.photo} />
										</ListItemAvatar>
										<ListItemText
											primary={referral.name}
											secondary={
												<Typography variant='body2' color='primary'>
													Điểm: {referral.point || 0}
												</Typography>
											}
										/>
									</ListItem>
								))}
							</List>
						</Box>
					</Box>
				)}
			</Box>
		</UserLayout>
	)
}

export default CustomerDetail
